module.exports = {
  ANFRAGE: { api: 'ANFRAGE', human: 'Anfrage' },
  ANGEBOT: { api: 'ANGEBOT', human: 'Angebot' },
  ANTRAG: { api: 'ANTRAG', human: 'Antrag' },
  VERTRAG: { api: 'VERTRAG', human: 'Vertrag' }
}
